export default build =>
    build.query({
        tagTypes: ['allYears'],
        keepUnusedDataFor: 1,
        query(payload) {
            console.log("in get event year",payload)            
            return {
                url: `/photogallery/getAllYears?page_number=${payload.page_number}&page_size=${payload.page_size}`,
                method: 'GET',              
            };
           
        },
       providesTags: ['allYears']
    })
